"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractListBodySchema = exports.ContractPriceSettlementSchema = exports.ContractCostsSchema = exports.ContractSingleCostSchema = exports.ContractCreateSchema = exports.BrokerageCreateSchema = exports.UnderlyingTermsCreateSchema = exports.PaymentCreateSchema = exports.DocumentsCreateSchema = exports.PackingCreateSchema = exports.ShippingCreateSchema = exports.PriceAndDestinationCreateSchema = exports.DeliveryCreateSchema = exports.PricingCreateSchema = exports.FlatPricingCreateSchema = exports.BasisPricingCreateSchema = exports.FumigationCreateSchema = exports.QualityCreateSchema = exports.QuantityCreateSchema = exports.GoodsCreateSchema = exports.SpecialTermsCreateSchema = void 0;
/* eslint-disable unicorn/no-thenable */
const currencies_types_1 = require("@myfrey/currencies-types");
const weight_units_types_1 = require("@myfrey/weight-units-types");
const DateFns = __importStar(require("date-fns"));
const joi_1 = __importDefault(require("joi"));
const types_1 = require("../types");
const defaultDateFormat = "yyyy-MM-dd";
const ISODateFormat = "yyyy-MM-dd'T'HH:mm:ss.SSSXXX";
const LCPayableAtSightName = "L/C payable at sight";
const arrayBaseError = "{{#label}} must be an array";
const anyRequiredError = "{{#label}} is a required field";
const anyRequiredSectionError = "{{#label}} is a required section";
const stringBaseError = "{{#label}} must be a string";
const anyOnlyError = "{{#label}} must be one of the allowed values";
const anyOnlyErrorWeightUnits = "{{#label}} must be one of the valid weight units";
const numberBaseError = "{{#label}} must be a number";
const arrayMinError = "{{#label}} must contain at least {{#limit}} item";
const numberPositiveError = "{{#label}} must be a positive number";
const currencyCodeName = "Currency Code";
const exchangeRateName = "Exchange Rate";
const specialTermsName = "Special Terms";
const dateValidator = (format) => (value, helpers) => {
    const parsed = DateFns.parse(value, format, new Date());
    if (!DateFns.isValid(parsed)) {
        return helpers.error("date.invalid");
    }
    return value;
};
const customErrorCode = "any.custom";
exports.SpecialTermsCreateSchema = joi_1.default
    .array()
    .items(joi_1.default.string())
    .messages({
    "any.required": anyRequiredError,
})
    .label(specialTermsName);
exports.GoodsCreateSchema = joi_1.default.object({
    option: joi_1.default.when("products", {
        is: joi_1.default
            .array()
            .required()
            .min(2)
            .messages({
            "array.base": arrayBaseError,
            "array.min": "{{#label}} must contain at least {{#limit}} items",
            "any.required": anyRequiredError,
        })
            .label("Products"),
        then: joi_1.default
            .string()
            .valid(...types_1.GoodsOptionList)
            .required()
            .messages({
            "string.base": stringBaseError,
            "any.only": anyOnlyError,
            "any.required": anyRequiredError,
        })
            .label("Option"),
        otherwise: joi_1.default
            .forbidden()
            .messages({
            "any.unknown": '{{#label}} is not allowed when "Products" condition is not met',
        })
            .label("Option"),
    }),
    products: joi_1.default
        .array()
        .items(joi_1.default
        .object({
        id: joi_1.default
            .number()
            .required()
            .messages({
            "number.base": numberBaseError,
            "any.required": anyRequiredError,
        })
            .label("Product"),
    })
        .required()
        .messages({
        "object.base": "{{#label}} must be an object",
        "any.required": anyRequiredError,
    })
        .label("Product"))
        .min(1)
        .messages({
        "array.base": arrayBaseError,
        "array.min": arrayMinError,
    })
        .label("Products"),
    cropYear: joi_1.default
        .string()
        .valid(...types_1.CropYearList)
        .optional()
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
    })
        .label("Crop Year"),
    name: joi_1.default
        .string()
        .required()
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
    })
        .label("Name"),
    specialTerms: exports.SpecialTermsCreateSchema,
});
exports.QuantityCreateSchema = joi_1.default.object({
    value: joi_1.default
        .number()
        .positive()
        .required()
        .messages({
        "number.base": numberBaseError,
        "number.positive": numberPositiveError,
        "any.required": anyRequiredError,
        "any.only": "{{#label}} must be equal to sum of quantity in deliveries",
    })
        .label("Quantity")
        .equal(joi_1.default.ref("/shipping.deliveries", {
        adjust: (value) => {
            // eslint-disable-next-line unicorn/no-array-reduce
            return value.reduce((sum, delivery) => sum + delivery.quantity, 0);
        },
    })),
    unit: joi_1.default
        .string()
        .required()
        .valid(...types_1.WeightUnitsListWithoutPounds)
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
        "any.only": anyOnlyError,
    })
        .label("Unit"),
    tolerance: joi_1.default
        .object({
        unit: joi_1.default
            .string()
            .required()
            .valid(...types_1.ToleranceUnitList)
            .messages({
            "string.base": stringBaseError,
            "any.required": anyRequiredError,
            "any.only": anyOnlyError,
        })
            .label("Unit"),
        value: joi_1.default
            .number()
            .required()
            .positive()
            .messages({
            "number.base": numberBaseError,
            "number.positive": numberPositiveError,
            "any.required": anyRequiredError,
        })
            .label("Value"),
        option: joi_1.default
            .string()
            .optional()
            .valid(...types_1.ToleranceOptionList)
            .messages({
            "string.base": stringBaseError,
            "any.only": anyOnlyError,
        })
            .label("Option"),
    })
        .optional(),
    specialTerms: exports.SpecialTermsCreateSchema,
});
exports.QualityCreateSchema = joi_1.default.object({
    grade: joi_1.default
        .string()
        .required()
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
    })
        .label("Grade"),
    allowance: joi_1.default
        .string()
        .valid(...types_1.QualityAllowanceList)
        .optional()
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
    })
        .label("Allowance"),
    term: joi_1.default
        .string()
        .valid(...types_1.QualityWeightTermList)
        .required()
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
        "any.required": anyRequiredError,
    })
        .label("Term"),
    lines: joi_1.default
        .array()
        .required()
        .items(joi_1.default.object({
        category: joi_1.default
            .string()
            .valid(...types_1.QualityCategoryList)
            .required()
            .messages({
            "string.base": stringBaseError,
            "any.only": anyOnlyError,
            "any.required": anyRequiredError,
        })
            .label("Category"),
        type: joi_1.default
            .string()
            .valid(...types_1.QualityTypeList)
            .optional()
            .messages({
            "string.base": stringBaseError,
            "any.only": anyOnlyError,
        })
            .label("Type"),
        additionalText: joi_1.default
            .string()
            .optional()
            .messages({
            "string.base": stringBaseError,
        })
            .label("Additional Text"),
        minimum: joi_1.default
            .number()
            .optional()
            .messages({
            "number.base": numberBaseError,
        })
            .label("Minimum"),
        basis: joi_1.default
            .number()
            .optional()
            .messages({
            "number.base": numberBaseError,
        })
            .label("Basis"),
        maximum: joi_1.default
            .number()
            .optional()
            .messages({
            "number.base": numberBaseError,
        })
            .label("Maximum"),
        forReferenceOnly: joi_1.default
            .boolean()
            .required()
            .messages({
            "boolean.base": "{{#label}} must be a boolean",
            "any.required": anyRequiredError,
        })
            .label("For Reference Only"),
    }))
        .messages({
        "array.base": arrayBaseError,
        "any.required": anyRequiredError,
    })
        .label("Lines"),
    specialTerms: exports.SpecialTermsCreateSchema,
});
exports.FumigationCreateSchema = joi_1.default.object({
    applied: joi_1.default
        .boolean()
        .required()
        .messages({
        "boolean.base": "{{#label}} must be a boolean",
        "any.required": anyRequiredError,
    })
        .label("Applied"),
    type: joi_1.default.when("applied", {
        is: joi_1.default.boolean().required().equal(true),
        then: joi_1.default
            .string()
            .valid(...types_1.FumigationTypeList)
            .optional()
            .messages({
            "string.base": stringBaseError,
            "any.only": anyOnlyError,
        })
            .label("Type"),
        otherwise: joi_1.default
            .forbidden()
            .messages({
            "any.unknown": '{{#label}} is not allowed when "applied" is false',
        })
            .label("Type"),
    }),
    specialTerms: exports.SpecialTermsCreateSchema,
});
exports.BasisPricingCreateSchema = joi_1.default.object({
    type: joi_1.default
        .string()
        .required()
        .valid("basis")
        .messages({
        "string.base": stringBaseError,
        "any.only": '{{#label}} must be "basis"',
        "any.required": anyRequiredError,
    })
        .label("Type"),
    futuresContractId: joi_1.default
        .number()
        .required()
        .messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    })
        .label("Futures Contract"),
    currencyCode: joi_1.default
        .string()
        .required()
        .valid(...currencies_types_1.Currencies.map(({ currencyCode }) => currencyCode))
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
        "any.required": anyRequiredError,
    })
        .label(currencyCodeName),
    exchangeRate: joi_1.default.when("currencyCode", {
        is: joi_1.default.string().valid("USD"),
        then: joi_1.default
            .forbidden()
            .messages({
            "any.unknown": '{{#label}} is not allowed when "currencyCode" is "USD"',
        })
            .label(exchangeRateName),
        otherwise: joi_1.default
            .number()
            .positive()
            .required()
            .messages({
            "number.base": numberBaseError,
            "number.positive": numberPositiveError,
            "any.required": anyRequiredError,
        })
            .label(exchangeRateName),
    }),
    basisPrice: joi_1.default
        .number()
        .required()
        .messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    })
        .label("Basis Price"),
    priceUnit: joi_1.default
        .string()
        .required()
        .valid(...types_1.WeightUnitsListWithoutPounds)
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
        "any.required": anyRequiredError,
    })
        .label("Price Unit"),
});
exports.FlatPricingCreateSchema = joi_1.default.object({
    type: joi_1.default
        .string()
        .required()
        .valid("flat")
        .messages({
        "string.base": stringBaseError,
        "any.only": '{{#label}} must be "flat"',
        "any.required": anyRequiredError,
    })
        .label("Type"),
    futuresContractId: joi_1.default
        .number()
        .optional()
        .messages({
        "number.base": numberBaseError,
    })
        .label("Futures Contract"),
    currencyCode: joi_1.default
        .string()
        .required()
        .valid(...currencies_types_1.Currencies.map(({ currencyCode }) => currencyCode))
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
        "any.required": anyRequiredError,
    })
        .label(currencyCodeName),
    exchangeRate: joi_1.default.when("currencyCode", {
        is: joi_1.default.string().valid("USD"),
        then: joi_1.default
            .forbidden()
            .messages({
            "any.unknown": '{{#label}} is not allowed when currencyCode is "USD"',
        })
            .label(exchangeRateName),
        otherwise: joi_1.default
            .number()
            .positive()
            .required()
            .messages({
            "number.base": numberBaseError,
            "number.positive": numberPositiveError,
            "any.required": anyRequiredError,
        })
            .label(exchangeRateName),
    }),
    priceUnit: joi_1.default
        .string()
        .valid(...types_1.WeightUnitsListWithoutPounds)
        .required()
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
        "any.required": anyRequiredError,
    })
        .label("Price Unit"),
    flatPrice: joi_1.default
        .number()
        .required()
        .messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    })
        .label("Flat Price"),
    basisPrice: joi_1.default
        .number()
        .optional()
        .messages({
        "number.base": numberBaseError,
    })
        .label("Basis Price"),
});
exports.PricingCreateSchema = joi_1.default.alternatives("one").try(exports.BasisPricingCreateSchema, exports.FlatPricingCreateSchema);
exports.DeliveryCreateSchema = joi_1.default.object({
    placeId: joi_1.default
        .number()
        .required()
        .messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    })
        .label("Place"),
    term: joi_1.default
        .string()
        .valid(...types_1.DeliveryTermList)
        .required()
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
        "any.required": anyRequiredError,
    })
        .label("Term"),
    places: joi_1.default
        .array()
        .optional()
        .min(1)
        .items(joi_1.default.object({
        locationId: joi_1.default
            .number()
            .required()
            .messages({
            "number.base": numberBaseError,
            "any.required": anyRequiredError,
        })
            .label("Location"),
        exercisePrice: joi_1.default
            .number()
            .required()
            .messages({
            "number.base": numberBaseError,
            "any.required": anyRequiredError,
        })
            .label("Exercise Price"),
        exercisePriceUnit: joi_1.default
            .string()
            .valid(...types_1.WeightUnitsListWithoutPounds)
            .required()
            .messages({
            "string.base": stringBaseError,
            "any.only": anyOnlyError,
            "any.required": anyRequiredError,
        })
            .label("Exercise Price Unit"),
    }))
        .messages({
        "array.base": arrayBaseError,
        "array.min": arrayMinError,
    })
        .label("Places"),
    deadline: joi_1.default.when("places", {
        is: joi_1.default.array().required().min(1),
        then: joi_1.default
            .custom(dateValidator(defaultDateFormat))
            .required()
            .messages({
            "any.required": '{{#label}} is a required field when "places" is provided',
            "date.base": "{{#label}} must be a valid date",
        })
            .label("Deadline"),
        otherwise: joi_1.default
            .forbidden()
            .messages({
            "any.unknown": '{{#label}} is not allowed when "places" is not provided',
        })
            .label("Deadline"),
    }),
    option: joi_1.default.when("places", {
        is: joi_1.default.array().required().min(1),
        then: joi_1.default
            .string()
            .valid(...types_1.DeliveryOptionList)
            .required()
            .messages({
            "string.base": stringBaseError,
            "any.only": anyOnlyError,
            "any.required": '{{#label}} is a required field when "places" is provided',
        })
            .label("Option"),
        otherwise: joi_1.default
            .forbidden()
            .messages({
            "any.unknown": '{{#label}} is not allowed when "places" is not provided',
        })
            .label("Option"),
    }),
});
exports.PriceAndDestinationCreateSchema = joi_1.default.object({
    pricing: exports.PricingCreateSchema.required()
        .messages({
        "any.required": anyRequiredError,
    })
        .label("Pricing"),
    delivery: exports.DeliveryCreateSchema.required()
        .messages({
        "any.required": anyRequiredError,
    })
        .label("Delivery"),
    specialTerms: exports.SpecialTermsCreateSchema.required(),
});
exports.ShippingCreateSchema = joi_1.default.object({
    specialTerms: exports.SpecialTermsCreateSchema.required(),
    deliveries: joi_1.default
        .array()
        .required()
        .min(1)
        .items(joi_1.default.object({
        quantity: joi_1.default
            .number()
            .required()
            .positive()
            .messages({
            "any.required": anyRequiredError,
            "number.positive": numberPositiveError,
            "any.custom": "Quantity value must be equal to sum of quantity in deliveries",
        })
            .label("Quantity")
            .custom((value, helpers) => {
            try {
                const contractQuantity = helpers.state.ancestors.at(-1).quantity.value;
                const shippingDeliveries = helpers.state.ancestors.at(1);
                const shippingDeliveriesQuantities = shippingDeliveries.map(({ quantity }) => quantity);
                const shippingDeliveriesQuantity = shippingDeliveriesQuantities.reduce((sum, quantity) => sum + (quantity === true ? value : quantity), 0);
                if (contractQuantity !== shippingDeliveriesQuantity) {
                    return helpers.error(customErrorCode);
                }
                return value;
            }
            catch {
                return helpers.error(customErrorCode);
            }
        }),
        unit: joi_1.default
            .string()
            .required()
            .valid(...types_1.WeightUnitsListWithoutPounds)
            .messages({
            "any.required": anyRequiredError,
            "any.only": anyOnlyErrorWeightUnits,
        })
            .label("Unit"),
        option: joi_1.default
            .string()
            .valid(...types_1.ShippingOptionList)
            .messages({
            "any.only": "{{#label}} must be one of the valid shipping options",
        })
            .label("Option"),
        periods: joi_1.default
            .array()
            .required()
            .min(1)
            .items(joi_1.default.object({
            start: joi_1.default
                .string()
                .custom(dateValidator(defaultDateFormat))
                .required()
                .messages({
                "any.required": anyRequiredError,
            })
                .label("Start"),
            end: joi_1.default
                .string()
                .custom(dateValidator(defaultDateFormat))
                .required()
                .messages({
                "any.required": anyRequiredError,
            })
                .label("End"),
            classification: joi_1.default
                .string()
                .valid(...types_1.ShippingClassificationList)
                .optional()
                .messages({
                "any.only": "{{#label}} must be one of the valid shipping classifications",
            })
                .label("Classification"),
        }))
            .messages({
            "array.min": arrayMinError,
            "any.required": anyRequiredError,
        })
            .label("Periods"),
    }))
        .messages({
        "array.min": arrayMinError,
        "any.required": anyRequiredError,
    })
        .label("Deliveries"),
});
exports.PackingCreateSchema = joi_1.default.object({
    option: joi_1.default.when("items", {
        is: joi_1.default.array().min(2).required(),
        then: joi_1.default
            .string()
            .valid(...types_1.PackingOptionList)
            .required()
            .messages({
            "any.required": '{{#label}} is a required field when "items" has at least {{#limit}} elements',
            "any.only": "{{#label}} must be one of the valid packing options",
        })
            .label("Option"),
        otherwise: joi_1.default
            .forbidden()
            .messages({
            "any.unknown": '{{#label}} is not allowed when "items" has less than {{#limit}} elements',
        })
            .label("Option"),
    }),
    items: joi_1.default
        .array()
        .min(1)
        .required()
        .items(joi_1.default
        .object({
        equipment: joi_1.default
            .string()
            .valid(...types_1.PackingTypeList)
            .required()
            .messages({
            "any.required": anyRequiredError,
            "any.only": "{{#label}} must be one of the valid packing types",
        })
            .label("Equipment"),
        minWeight: joi_1.default
            .number()
            .positive()
            .optional()
            .messages({
            "number.positive": numberPositiveError,
        })
            .label("Min Weight"),
        maxWeight: joi_1.default
            .number()
            .positive()
            .optional()
            .messages({
            "number.positive": numberPositiveError,
        })
            .label("Max Weight"),
        unit: joi_1.default
            .string()
            .optional()
            .valid(...types_1.WeightUnitsListWithoutPounds)
            .messages({
            "any.only": anyOnlyErrorWeightUnits,
        })
            .label("Unit"),
        priceAdjustment: joi_1.default
            .number()
            .optional()
            .messages({
            "number.base": numberBaseError,
        })
            .label("Price Adjustment"),
        priceAdjustmentUnit: joi_1.default
            .string()
            .optional()
            .valid(...types_1.WeightUnitsListWithoutPounds)
            .messages({
            "any.only": anyOnlyErrorWeightUnits,
        })
            .label("Price Adjustment Unit"),
    })
        .messages({
        "any.required": anyRequiredError,
        "array.min": arrayMinError,
    })
        .label("Items")),
    specialTerms: exports.SpecialTermsCreateSchema,
});
exports.DocumentsCreateSchema = joi_1.default.object({
    items: joi_1.default
        .array()
        .required()
        .min(1)
        .items(joi_1.default
        .object({
        type: joi_1.default
            .string()
            .valid(...types_1.DocumentTypeList)
            .required()
            .messages({
            "any.required": anyRequiredError,
            "any.only": "{{#label}} must be one of the valid document types",
        })
            .label("Type"),
        issuer: joi_1.default
            .string()
            .valid(...types_1.DocumentIssuerList)
            .optional()
            .messages({
            "any.only": "{{#label}} must be one of the valid document issuers",
        })
            .label("Issuer"),
        description: joi_1.default
            .string()
            .optional()
            .messages({
            "string.base": stringBaseError,
        })
            .label("Description"),
    })
        .messages({
        "any.required": anyRequiredError,
        "array.min": arrayMinError,
    })
        .label("Items")),
    specialTerms: exports.SpecialTermsCreateSchema,
});
exports.PaymentCreateSchema = joi_1.default.object({
    terms: joi_1.default
        .array()
        .custom((terms, helpers) => {
        // eslint-disable-next-line unicorn/no-array-callback-reference
        const lcTerms = terms.filter(types_1.isLCPaymentInput);
        if (lcTerms.length <= 1)
            return terms;
        const openingDueDates = new Set(lcTerms.map(({ openingDueDate }) => (0, types_1.isDateAbsolute)(openingDueDate) ? openingDueDate.date : openingDueDate.relativeDays));
        if (openingDueDates.size > 1) {
            return helpers.error("any.custom", { error: new Error("Multiple openingDueDates") });
        }
        return terms;
    })
        .required()
        .min(1)
        .items(joi_1.default
        .object({
        method: joi_1.default
            .string()
            .required()
            .allow(...types_1.PaymentMethodNames)
            .messages({
            "any.required": anyRequiredError,
            "any.allowOnly": "{{#label}} must be one of the valid payment methods",
        })
            .label("Method"),
        percentage: joi_1.default
            .number()
            .required()
            .max(100)
            .min(0)
            .messages({
            "number.base": numberBaseError,
            "number.max": "{{#label}} must be less than or equal to {{#limit}}",
            "number.min": "{{#label}} must be greater than or equal to {{#limit}}",
            "any.required": anyRequiredError,
        })
            .label("Amount"),
        time: joi_1.default.when("method", {
            is: joi_1.default.string().required().valid(LCPayableAtSightName),
            then: joi_1.default.forbidden(),
            otherwise: joi_1.default
                .number()
                .required()
                .integer()
                .positive()
                .allow(0)
                .messages({
                "number.base": numberBaseError,
                "number.integer": "{{#label}} must be an integer",
                "number.positive": numberPositiveError,
                "any.required": anyRequiredError,
            })
                .label("Time"),
        }),
        unit: joi_1.default.when("method", {
            is: joi_1.default.string().required().valid(LCPayableAtSightName),
            then: joi_1.default
                .forbidden()
                .messages({
                "any.unknown": '{{#label}} is not allowed when "method" is LCPayableAtSightName',
            })
                .label("Unit"),
            otherwise: joi_1.default
                .string()
                .required()
                .valid(...types_1.PaymentTimeUnitList)
                .messages({
                "string.base": stringBaseError,
                "any.required": anyRequiredError,
                "any.only": "{{#label}} must be one of the valid payment time units",
            })
                .label("Unit"),
        }),
        openingDueDate: joi_1.default
            .when("method", {
            is: joi_1.default.string().required().valid(LCPayableAtSightName, "L/C usance"),
            then: joi_1.default
                .alternatives()
                .match("one")
                .try(joi_1.default
                .object({
                date: joi_1.default
                    .string()
                    .custom(dateValidator(defaultDateFormat))
                    .required()
                    .messages({
                    "any.required": anyRequiredError,
                    "string.base": stringBaseError,
                })
                    .label("Date"),
            })
                .required(), joi_1.default
                .object({
                relativeDays: joi_1.default
                    .number()
                    .required()
                    .integer()
                    .positive()
                    .allow(0)
                    .messages({
                    "number.base": numberBaseError,
                    "number.integer": "{{#label}} must be an integer",
                    "number.positive": numberPositiveError,
                    "any.required": anyRequiredError,
                })
                    .label("Relative Days"),
            })
                .required()),
            otherwise: joi_1.default.forbidden(),
        })
            .required(),
    })
        .required())
        .messages({
        "array.base": arrayBaseError,
        "array.min": arrayMinError,
        "any.required": anyRequiredError,
        "any.custom": "Custom validation error: {#error.message}",
    })
        .label("Terms"),
    specialTerms: exports.SpecialTermsCreateSchema,
});
exports.UnderlyingTermsCreateSchema = joi_1.default.object({
    type: joi_1.default
        .string()
        .valid(...types_1.UnderlyingTermList)
        .required()
        .messages({
        "any.required": anyRequiredError,
        "any.only": "{{#label}} must be one of the valid",
    })
        .label("Underlying term"),
});
exports.BrokerageCreateSchema = joi_1.default.object({
    brokerId: joi_1.default
        .number()
        .required()
        .messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    })
        .label("Broker"),
    payer: joi_1.default
        .string()
        .required()
        .valid(...types_1.BrokerageOptionList)
        .messages({
        "any.required": anyRequiredError,
        "any.only": "{{#label}} must be one of the valid brokerage options",
    })
        .label("Payer"),
});
exports.ContractCreateSchema = joi_1.default.object({
    traderId: joi_1.default.number().required().label("Trader").messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    }),
    date: joi_1.default.required().custom(dateValidator(defaultDateFormat)).label("Date").messages({
        "any.required": anyRequiredError,
        "any.custom": "{{#label}} must be in the correct format",
    }),
    externalReference: joi_1.default.string().optional().label("External Reference"),
    boteId: joi_1.default.string().optional().label("BoteId"),
    status: joi_1.default
        .string()
        .valid(...types_1.ContractStatusList)
        .optional()
        .messages({
        "string.base": stringBaseError,
        "any.only": anyOnlyError,
    })
        .label("Status"),
    buyerId: joi_1.default
        .string()
        .required()
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
    })
        .label("Buyer"),
    sellerId: joi_1.default
        .string()
        .required()
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
    })
        .label("Seller"),
    goods: exports.GoodsCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Goods"),
    quantity: exports.QuantityCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Quantity"),
    quality: exports.QualityCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Quality"),
    fumigation: exports.FumigationCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Fumigation"),
    priceAndDestination: exports.PriceAndDestinationCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Price and Destination"),
    shipping: exports.ShippingCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Shipping"),
    packing: exports.PackingCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Packing"),
    documents: exports.DocumentsCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Documents"),
    payment: exports.PaymentCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Payment"),
    underlyingTerms: exports.UnderlyingTermsCreateSchema.required()
        .messages({
        "any.required": anyRequiredSectionError,
    })
        .label("Underlying Terms"),
    brokerage: exports.BrokerageCreateSchema.optional()
        .messages({
        "any.optional": "{{#label}} is an optional section",
    })
        .label("Brokerage"),
    specialTerms: exports.SpecialTermsCreateSchema,
});
exports.ContractSingleCostSchema = joi_1.default.object({
    currencyCode: joi_1.default
        .string()
        .required()
        .valid(...currencies_types_1.Currencies.map(({ currencyCode }) => currencyCode))
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
        "any.only": anyOnlyError,
    })
        .label(currencyCodeName),
    level: joi_1.default
        .string()
        .required()
        .valid(...weight_units_types_1.AllWeightUnitsList)
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
        "any.only": anyOnlyError,
    })
        .label("Level"),
    typeId: joi_1.default
        .string()
        .required()
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
    })
        .label("Type"),
    value: joi_1.default
        .number()
        .required()
        .messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    })
        .label("Value"),
});
exports.ContractCostsSchema = joi_1.default
    .array()
    .required()
    .min(1)
    .items(exports.ContractSingleCostSchema)
    .messages({
    "array.base": "{{#label}} must be an array",
    "array.min": "{{#label}} must contain at least {{#limit}} item(s)",
    "any.required": anyRequiredError,
})
    .label("ContractCostsSchema");
exports.ContractPriceSettlementSchema = joi_1.default
    .object({
    currencyCode: joi_1.default
        .string()
        .required()
        .valid(...currencies_types_1.Currencies.map(({ currencyCode }) => currencyCode))
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
        "any.only": anyOnlyError,
    })
        .label("currencyCode"),
    price: joi_1.default
        .number()
        .required()
        .messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    })
        .label("price"),
    priceUnit: joi_1.default
        .string()
        .required()
        .valid(...weight_units_types_1.WeightUnitsList)
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
        "any.only": anyOnlyError,
    })
        .label("priceUnit"),
    quantity: joi_1.default
        .number()
        .required()
        .messages({
        "number.base": numberBaseError,
        "any.required": anyRequiredError,
    })
        .label("quantity"),
    quantityUnit: joi_1.default
        .string()
        .required()
        .valid(...weight_units_types_1.WeightUnitsList)
        .messages({
        "string.base": stringBaseError,
        "any.required": anyRequiredError,
        "any.only": anyOnlyError,
    })
        .label("quantityUnit"),
    settlementDate: joi_1.default
        .custom(dateValidator(ISODateFormat))
        .required()
        .messages({
        "any.required": anyRequiredError,
        "any.custom": "{{#label}} must be a valid date",
    })
        .label("settlementDate"),
})
    .required()
    .messages({
    "object.base": "{{#label}} must be an object",
    "any.required": anyRequiredError,
})
    .label("ContractPriceSettlementSchema");
exports.ContractListBodySchema = joi_1.default
    .array()
    .required()
    .min(1)
    .items(joi_1.default.alternatives(joi_1.default.number().integer().required(), joi_1.default.string().required()));
